import { Dispatch } from 'react';
import { networkCall, apiBaseUrl } from '../../utils/networkCall';
import isEmpty from 'lodash/isEmpty';

export const CALCULATE_PAYABLE_LOADING = "CALCULATE_PAYABLE_LOADING";
export const CALCULATE_PAYABLE_SUCCESS = "CALCULATE_PAYABLE_SUCCESS";
export const CALCULATE_PAYABLE_FAILED = "CALCULATE_PAYABLE_FAILED";

export const GET_ORDER_ID_LOADING: string = "GET_ORDER_ID_LOADING";
export const GET_ORDER_ID_SUCCESS: string = "GET_ORDER_ID_SUCCESS";
export const GET_ORDER_ID_FAILED: string = "GET_ORDER_ID_FAILED";

export const calculatePayableAmount = (pending_amount: number, cb: (status: boolean, data: any) => void) => {

    return (dispatch: Dispatch<any>) => {
        dispatch({ type: CALCULATE_PAYABLE_LOADING });

        networkCall(`get`, `/calculate-payable?value_in_base_currency=${pending_amount}`, apiBaseUrl.baseUrl).then((res: any) => {

            if (res?.data) {
                dispatch({ type: CALCULATE_PAYABLE_SUCCESS, payload: { res: res?.data } });
                cb(true, res.data);
            }
            else {
                dispatch({ type: CALCULATE_PAYABLE_FAILED, payload: { error: res } });
                cb(false, res);
            }
        }).catch((err: any) => {
            dispatch({ type: CALCULATE_PAYABLE_FAILED, payload: { error: err } });
            cb(false, err.response.data);
        });
    }
}
export const getTanNumberDetails = (cb: (status: boolean, data: any) => void) => {

    return (dispatch: Dispatch<any>) => {
        dispatch({ type: CALCULATE_PAYABLE_LOADING });

        networkCall(`get`, `/kycdetails`, apiBaseUrl.baseUrl).then((res: any) => {

            if (res?.data) {
                cb(true, res.data);
            }
            else {
                cb(false, res);
            }
        }).catch((err: any) => {
            cb(false, err.response.data);
        });
    }
}

export const getOrderId = (dataToSend: object, cb: (status: boolean, data: any) => void) => {
    return (dispatch: Dispatch<any>) => {
        dispatch({ type: GET_ORDER_ID_LOADING });
        networkCall(
            `post`,
            `/checkout`,
            apiBaseUrl.baseUrl,
            true,
            true,
            dataToSend
        )
            .then((res: any) => {
                if (res.data && isEmpty(res.error)) {
                    cb(true, res.data);
                } else {
                    cb(false, res);
                }
            }).catch((error) => {
                if (error?.response?.data) {
                    cb(false, error.response.data);
                }
            });
    }
};
export const WaDeduction = (cb: (status: boolean, data: any) => void) => {
    return (dispatch: Dispatch<any>) => {
        dispatch({ type: GET_ORDER_ID_LOADING });
        networkCall(
            `post`,
            `/wa-deduction`,
            apiBaseUrl.baseUrl,
            true,
            true
        )
            .then((res: any) => {
                if ( isEmpty(res.error)) {
                    cb(true, res);
                } else {
                    cb(false, res);
                }
            }).catch((error) => {
                if (error?.response?.data) {
                    cb(false, error.response.data);
                }
            });
    }
};